/* global __HOT__ */
/* eslint-disable import/no-unresolved */

// @jsx h

import { h, render } from 'preact'
import { testPositionSticky } from '@nrk/feature-tests'
import { toArray, createUniqueId } from '@nrk/dh-utils'
import { createErrorReporter } from '../lib/errorReporting'
import { App } from './components/App'
import { root as rootElementClassName } from './components/App.css'
import { createGoogleAnalyticsTracker } from '@nrk/dh-analytics-utils'
import { getContextId } from '../lib/getContextId'
import { Provider as CustomProvider } from '../lib/provider'

window[rootElementClassName] = window[rootElementClassName] || {}

function init (mapboxgl) {
  findElements(rootElementClassName).forEach(el => {
    el.id = createUniqueId()
    window[rootElementClassName][el.id] = true

    // Extract values sent from server
    const name = el.getAttribute('data-name')
    const preloadedState = JSON.parse(el.getAttribute('data-preloaded-state'))
    const errorTrackingEnabled = el.getAttribute('data-error-tracking-enabled') === 'true'

    // setup error reporting
    const simpleErrorReport = createErrorReporter(name, errorTrackingEnabled)
    simpleErrorReport.listenAndCatch()

    // Extract metadata required to create google analytics tracker
    const gaPropertyId = el.getAttribute('data-ga-property-id')
    const metadata = JSON.parse(el.getAttribute('data-metadata'))
    const { title, selfId, published } = metadata

    // create google analytics tracker
    const googleAnalyticsTracker = createGoogleAnalyticsTracker({
      name: 'dh',
      gaPropertyId,
      self: {
        id: selfId,
        title,
        publishedDate: published ? new Date(published) : null
      },
      context: {
        id: getContextId(document.location.href)
      }
    })

    const sendError = (message) => {
      simpleErrorReport.sendErrorReport({ message })
    }

    const sendGaEvent = (eventObj) => {
      googleAnalyticsTracker.sendEvent({
        category: `dh-modul-${name}`,
        ...eventObj
      })
    }

    // Test if the browser is modern enough
    testPositionSticky(supported => {
      if (!supported) {
        simpleErrorReport.sendErrorReport({ message: 'Warning: This browser does not support `position: sticky`' })

        return
      }
      if (!mapboxgl.supported()) {
        simpleErrorReport.sendErrorReport({ message: 'Warning: This browser does not support mapbox-gl' })

        return
      }

      // ... and render with the exact same props
      el.className = el.className.replace('noJs', 'js')
      // render(<App {...preloadedState} />, el, el.firstChild)

      render(
        <CustomProvider sendGaEvent={sendGaEvent} sendError={sendError}>
          <App {...preloadedState} />
        </CustomProvider>, el, el.firstChild
      )
    })

    // Enable webpack hot-reloading
    if (__HOT__) {
      // Reload and re-render preact application
      module.hot.accept('./client', () => {
        const { App } = require('./components/App')
        const { Provider: CustomProvider } = require('../lib/provider')
        render(
          <CustomProvider sendGaEvent={sendGaEvent} sendError={sendError}>
            <App {...preloadedState} />
          </CustomProvider>, el, el.firstChild)
      })
    }
  })
}

if (__HOT__) {
  require('preact/debug')
}

function findElements (className) {
  return toArray(document.getElementsByClassName(className)).filter(el => !isInitialized(el, className))
}

function isInitialized (el, className) {
  return el.id && window[className][el.id]
}

window.initJordenRundtSeksSteg = init



// WEBPACK FOOTER //
// ./src/v1/client.js